
import SEO from "../../components/seo";
//import LayoutFour from "../../layouts/LayoutFour";
//import NewsletterTwo from "../../wrappers/newsletter/NewsletterTwo";
import HeroSliderEleven from "../../wrappers/hero-slider/HeroSliderEleven";
//import CategoryTwoSlider from "../../wrappers/category/CategoryTwoSlider";
//import TabProductSix from "../../wrappers/product/TabProductSix";
import FeatureIconFive from "../../wrappers/feature-icon/FeatureIconFive";
import BannerThirtyEight from "../../wrappers/banner/BannerThirtyEight";
import { Link } from "react-router-dom";
import LayoutOne from "../../layouts/LayoutOne";
//import clsx from "clsx";
import SectionTitle from "../../components/section-title/SectionTitle";
import { useState } from "react";
import HeroSliderEight from "../../wrappers/hero-slider/HeroSliderEight";

import { IconAgrupacion, IconConvenios, IconDespacho, IconListado, IconMedicamento, IconPago, IconQuimicos, IconRegulatoriosCituc, IconRegulatoriosListaMedicamentos, IconRegulatoriosUsoRacional, IconUbicacion } from "../../components/icons-home";
import { useNavigate } from "react-router-dom";
import iconEpilepsia from '../../assets/home/iconos-front/epilepsia.svg'
import iconSaludMental from '../../assets/home/iconos-front/salud-mental.svg'
import iconAnalgesicos from '../../assets/home/iconos-front/analgesicos.svg'
import iconAntiinfeccioso from '../../assets/home/iconos-front/antiinfeccioso.svg'
import iconCardiometabolico from '../../assets/home/iconos-front/cardiometabolicos.svg'
import iconDermatologico from '../../assets/home/iconos-front/dermatologico.svg'
import iconGastrointestinal from '../../assets/home/iconos-front/gastrointestinal.svg'
import iconHormonas from '../../assets/home/iconos-front/hormonas.svg'
import iconHuesos from '../../assets/home/iconos-front/huesos.svg'
import iconOftalmologico from '../../assets/home/iconos-front/oftalmologico.svg'
import iconRespiratorio from '../../assets/home/iconos-front/respiratorio.svg'
import iconVitaminas from '../../assets/home/iconos-front/vitaminas.svg'
import iconCenabast from '../../assets/home/iconos-front/icon-cenabast.png'
import iconInsumos from '../../assets/home/iconos-front/insumos.svg'
import iconFemeninas from '../../assets/home/iconos-front/femeninas.svg'
import iconMasculinas from '../../assets/home/iconos-front/masculinos.svg'
import iconEspecificas from '../../assets/home/iconos-front/especificas.svg'
import iconImportaciones from '../../assets/home/iconos-front/importaciones.svg'
import { Button } from "react-bootstrap";

const HomeVentaOnline = ({ spaceBottomClass }) => {
  const navigate = useNavigate();
  const [masCategorias, setMasCategorias] = useState(false)

  const [arrCategorias, setArrCategorias] = useState([
    {
      icon: iconEpilepsia,
      nombre: 'EPILEPSIA ANTICRISIS',
      mensaje: "Contamos con un gran stock de medicamentos para la epilepsia",
      link: 'EPILEPSIA ANTICRISIS',
    },
    {
      icon: iconSaludMental,
      nombre: 'SALUD MENTAL',
      mensaje: "Contamos con un gran stock de medicamentos para la salud mental",
      link: 'SALUD MENTAL',
    },
    {
      icon: iconAnalgesicos,
      nombre: 'DOLOR Y ANALGÉSICOS',
      link: 'DOLOR Y ANALGESICOS',
    },
    {
      icon: iconAntiinfeccioso,
      nombre: 'ANTIINFECCIOSOS',
      link: 'ANTIINFECCIOSOS',
    },
    {
      icon: iconCardiometabolico,
      nombre: 'CARDIO-METABÓLICOS',
      link: 'CARDIOMETABOLICOS',
    },
    {
      icon: iconDermatologico,
      nombre: 'DERMATOLÓGICOS',
      link: 'DERMATOLOGICOS',
    },
    {
      icon: iconGastrointestinal,
      nombre: 'GASTRO-INTESTINALES',
      link: 'GASTROINTESTINALES',
    },
    {
      icon: iconHormonas,
      nombre: 'HORMONAS',
      link: 'HORMONAS',
    },
    {
      icon: iconHuesos,
      nombre: 'HUESOS Y ARTICULACIONES',
      link: 'HUESOS Y ARTICULACIONES',
    },
    {
      icon: iconOftalmologico,
      nombre: 'OFTALMOLÓGICOS',
      link: 'OFTALMOLOGICOS',
    },
    {
      icon: iconRespiratorio,
      nombre: 'RESPIRATORIOS Y ALERGIAS',
      link: 'RESPIRATORIOS Y ALERGIAS',
    },
    {
      icon: iconVitaminas,
      nombre: 'VITAMINAS - MINERALES - SUPLEMENTOS - HOMEOPÁTICOS',
      link: 'VITAMINAS - MINERALES - SUPLEMENTOS - HOMEPATICOS'
    },
    {
      icon: iconEspecificas,
      nombre: 'ENFERMEDADES ESPECÍFICAS',
      link: 'ENFERMEDADES ESPECIFICAS',
    },
    {
      icon: iconMasculinas,
      nombre: 'SALUD MASCULINA',
      link: 'SALUD MASCULINA',
    },
    {
      icon: iconFemeninas,
      nombre: 'SALUD FEMENINA',
      link: 'SALUD FEMENINA',
    },
    {
      icon: iconInsumos,
      nombre: 'INSUMOS',
      link: 'INSUMOS',
    },
    {
      icon: iconCenabast,
      nombre: 'CENABAST',
      link: 'CENABAST',
    },
    {
      icon: iconImportaciones,
      nombre: 'IMPORTACIONES',
      link: 'IMPORTACIONES',
    }
  ])


  return (
    <LayoutOne>
      <SEO
        titleTemplate="Liga Chilena contra la Epilepsia"
        //title="Venta Online 2.0 - Liga Chilena contra la Epilepsia"
        description="Venta Online 2.0"
      />
      {/* titulo principal */}
      {/* <div className="container pt-20 pb-20">

        <SectionTitle
          titleText="Farmacia Online – Liga Chilena contra la Epilepsia"
          //subtitleText="But I must explain to you how all this mistaken idea of denouncing."
          positionClass="text-center"
          borderClass="no-border"

        />
        <h4 className="pt-20 pb-20">Venta desde Farmacia Liga Chilena contra la Epilepsia, Erasmo Escala 2220, Santiago.

          Los precios indicados en este sitio son iguales en todas nuestras farmacias, para conocer nuestra lista de precios <a href="https://compra.ligaepilepsia.cl/wp-content/uploads/2022/10/ListaMed-noviembre-2023-WEB.pdf" target="_blank" rel="noreferrer">haz clic aquí</a></h4>
      </div> */}


      {/* hero slider */}
      {/* <HeroSliderEleven /> */}
      <HeroSliderEight />

      {/* columnas de envio*/}
      {/* <FeatureIconFive spaceTopClass="pt-100" /> */}


      <div className="container pt-3 pb-3 banner-home">
        <div className="row" style={{ display: "inline-flex" }}>
          <div className="col-md-6 col-lg-3 col-xl-3 col-sm-6 col-xs-6 col-6">
            <div className="interior row">
              <div className="col-md-3 col-lg-3 col-xl-3 col-sm-4 col-xs-4 col-4">
                <div className="align-items-center icon-box justify-content-center">

                  <img src={'/assets/img/home/medicamentos.png'} 
                  style={{width: '70px', height: '70px'}}
                  />

                </div>
              </div>
              <div className="col-md-9 col-lg-9 col-xl-9 col-sm-8 col-xs-8 col-8 text-box">
                <h5>{"Somos Especialistas"}</h5>
                <p>{"Con amplio stock de medicamentos en uso crónico."}</p>
              </div>
            </div>

          </div>
          <div className="col-md-6 col-lg-3 col-xl-3 col-sm-6 col-xs-6 col-6 ">
            <div className="interior row">
              <div className="col-md-3 col-lg-3 col-xl-3 col-sm-4 col-xs-4 col-4">
                <div className="align-items-center icon-box justify-content-center">
                <img src={'/assets/img/home/sin-inscripcion.png'} 
                  style={{width: '70px', height: '70px'}}
                  />
                </div>
              </div>
              <div className="col-md-9 col-lg-9 col-xl-9 col-sm-8 col-xs-8 col-8 text-box">
                <h5>{"Sin inscripción"}</h5>
                <p>{"Estamos abiertos a todo público."}</p>

              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 col-xl-3 col-sm-6 col-xs-6 col-6">
            <div className="interior row">
              <div className="col-md-3 col-lg-3 col-xl-3 col-sm-4 col-xs-4 col-4">
                <div className="align-items-center icon-box justify-content-center">
                <img src={'/assets/img/home/despacho.png'} 
                  style={{width: '70px', height: '70px'}}
                  />
                </div>
              </div>
              <div className="col-md-9 col-lg-9 col-xl-9 col-sm-8 col-xs-8 col-8 text-box">
                <h5>{"A domicilio"}</h5>
                <p>{"Despacho en RM y Concepción, incluido refrigerados."}</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 col-xl-3 col-sm-6 col-xs-6 col-6 ">
            <div className="interior row">
              <div className="col-md-3 col-lg-3 col-xl-3 col-sm-4 col-xs-4 col-4">
                <div className="align-items-center icon-box justify-content-center">
                <img src={'/assets/img/home/pago-seguro.png'} 
                  style={{width: '70px', height: '70px'}}
                  />
                </div>
              </div>
              <div className="col-md-9 col-lg-9 col-xl-9 col-sm-8 col-xs-8 col-8 text-box">
                <h5>{"Paga seguro"}</h5>
                <p>{"Tenemos un sistema seguro de pago."}</p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="info-liga fondo-gradiente pb-40">
        <div className="container pt-40 pb-40">
          <h2 className="titulo text-center pb-20">Categorías</h2>
          <div className="row">
            {arrCategorias.slice(0, 2).map((element, index) => (
              <div
                key={index}
                className="col-md-6 col-lg-6 col-xl-6 col-sm-6 col-xs-12 col-12">
                <div
                  onClick={() => navigate(process.env.PUBLIC_URL + `/medicamentos?categoria=${element.link}`)}
                  style={{ borderRadius: "20px", backgroundColor: "white", marginBlock: "7px", marginInline: "-2px" }}
                  className="row contenedor-categoria front-categorias">
                  <div className="col-5 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(105, 75, 153, 0.4)", borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px" }}>
                    <img
                      className="p-4 "
                      src={element.icon}
                    />
                  </div>
                  <div className="col-7 align-self-center">
                    <Link className="titulos-categoria text-capitalize" to={process.env.PUBLIC_URL + `/medicamentos?categoria=${element.link}`} >{element.nombre.toLowerCase()}</Link>
                    <p className="subtitulo-categoria pt-1">{element.mensaje}</p>
                  </div>
                </div>
              </div>
            ))}

            {
              arrCategorias.slice(2, !masCategorias ? 22 : 10).map((element, index) => (
                <div
                  key={index}
                  className="col-md-4 col-lg-3 col-xl-3 col-sm-3 col-xs-6 col-6">

                  <div
                    onClick={() => element.nombre === "IMPORTACIONES" ? navigate(process.env.PUBLIC_URL + "/importaciones") : navigate(process.env.PUBLIC_URL + `/medicamentos?categoria=${element.link}`)}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "white",
                      marginBlock: "7px",
                      marginInline: "-2px",
                      height: 120
                    }}
                    className="row contenedor-categoria d-none d-sm-flex">


                    <div
                      className="col-5 d-flex justify-content-center align-items-center"
                      style={{ backgroundColor: "rgba(105, 75, 153, 0.4)", borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px" }}

                    >
                      <img
                        className=""
                        src={element.icon}
                      />
                    </div>
                    <div className="col-7 align-self-center p-2">
                      <Link className="titulos-categoria-bajo text-capitalize" to={process.env.PUBLIC_URL + `/medicamentos?categoria=${element.link}`} >{element.nombre.toLowerCase()}</Link>

                    </div>
                  </div>

                  <div className="d-flex d-sm-none"
                    onClick={() => element.nombre === "IMPORTACIONES" ? navigate(process.env.PUBLIC_URL + "/importaciones") : navigate(process.env.PUBLIC_URL + `/medicamentos?categoria=${element.link}`)}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "white",
                      marginBlock: "7px",
                      marginInline: "-2px",
                      height: 80,

                    }}

                  >
                    <div className="align-items-center d-flex" style={{ backgroundColor: "rgba(105, 75, 153, 0.4)", borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", alignContent: "center" }}
                    >

                      <div className="col-4" style={{ paddingInline: "5px" }}>

                        <img
                          className=""
                          src={element.icon}
                          style={{ width: "50px", height: "50px" }}
                        />


                      </div>
                    </div>
                    <div className="col-8 align-content-center" style={{ paddingInlineStart: "2px", lineHeight: "18px" }}>
                      <Link className="titulos-categoria-bajo text-capitalize" to={process.env.PUBLIC_URL + `/medicamentos?categoria=${element.link}`} >{element.nombre.toLowerCase()}</Link>

                    </div>

                  </div>


                </div>
              ))
            }




            <div className="text-center d-block d-sm-none">

              <p style={{ color: "#fff" }}
                onClick={() => setMasCategorias(!masCategorias)}
              >{masCategorias ? "Ver mas categorías..." : "Ocultar"}

                <i
                  style={{ fontSize: "30px", position: "absolute" }}
                  className={masCategorias ? "pe-7s-angle-down" : "pe-7s-angle-up"} /></p>
            </div>




            {/* {arrCategorias.map((categoria, index) => {
              return (
                <div className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-xs-6 col-6 interior text-center" key={index}>
                  <Link style={{ fontSize: 14 }} to={`/medicamentos?categoria=${categoria.nombre}`} className="titulo">{categoria.nombre}</Link>
                </div>
              )
            }

            )} */}
          </div>


        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-6 col-xl-6 col-sm-6 col-xs-12 col-12 text-center align-items-center align-self-center justify-content-center">
              <img src="/assets/img/info-liga.png" style={{ maxWidth: "inherit", maxHeight: "inherit" }}  />
            </div>
            <div className="col-md-6 col-lg-6 col-xl-6 col-sm-6 col-xs-12 col-12 texto-interior">
              <h1>{"Nuestras farmacias son sin fines de lucro."}</h1>
              <p className="titulo">{"Estamos abiertos a todo público y contamos con precios más convenientes."}</p>
              <p className="titulo pb-4">{"Al preferir nuestras farmacias estarás ayudando a una persona con epilepsia."}</p>
              <Link to={"https://www.ligaepilepsia.cl"} target="_blank"
                className="btn-liga">
                {"Conoce La Liga"}
              </Link>
            </div>
          </div>

        </div>
      </div>


      <div className="container regulatorios mb-60">
        {/* <div className="text-center">
          <h2 className="titulo">Enlaces regulatorios</h2>
        </div> */}


        {/* <div className="row">
          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 imagen">
            <a target="_blank" rel="noreferrer" href="https://www.minsal.cl/medicamentos_uso_racional/" >
              <img src="/assets/img/uso-racional.jpg" alt="uso racional" />
            </a>
          </div>
          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 imagen">
            <a target="_blank" rel="noreferrer" href="http://cituc.uc.cl/">
              <img src="/assets/img/cituc.jpg" alt="cituc" /></a>
          </div>

          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 imagen seccion-cenabast p-2">
            <img src="/assets/img/cenabast.png" alt="uso racional" className="cenabast" />
            <p className="cenabast-texto">Revisa nuestros medicamentos CENABAST</p>
            <button className="boton">Aquí</button>
          </div>

        </div> */}
        <div className="row">
          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 pt-2">
            <div className=" regulatorios-box align-items-center d-flex">
              <div className="col-4 text-center">
                <IconRegulatoriosCituc />
              </div>
              <div className="col-8 text-start">
                <a
                  target="_blank" rel="noreferrer" href="http://cituc.uc.cl/" >
                  {" Emergencias toxicológicas Cituc"}
                </a>
              </div>

            </div>

          </div>
          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 pt-2">
            <div className=" regulatorios-box align-items-center d-flex">
              <div className="col-4 text-center"  >
                <IconRegulatoriosListaMedicamentos />
              </div>
              <div className="col-8 text-start" >
                <a target="_blank" rel="noreferrer" 
                
                href="/assets/archivos/ListaMed-abril-Oct2025-WEB.pdf" >
                  {"Revisa nuestra lista de medicamentos"}
                </a>
              </div>

            </div>

          </div>
          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 pt-2">
            <div className=" regulatorios-box align-items-center d-flex">
              <div className="col-4 text-center">
                <IconRegulatoriosUsoRacional />
              </div>
              <div className="col-8 text-start">
                <a target="_blank" rel="noreferrer" href="https://www.minsal.cl/medicamentos_uso_racional/" >
                  {"Uso racional de medicamentos"}
                </a>
              </div>

            </div>

          </div>

        </div>

      </div>

      {/* <div className="container pt-50 sedes pb-70">

        <div className="row">
          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 interior">
            <p className="titulo">Sede Erasmo Escala</p>
            <p className="datos"><span>Dirección: </span> Erasmo Escala 2220, Santiago Centro</p>
            <p className="datos"><span>Teléfono: </span> 600 300 1515</p>
            <p className="datos"><span>Correo: </span> erasmoescala@liche.cl</p>
            <p className="datos"><span>Horario de atencion: </span> </p>
            <p className="datos">Lunes a Viernes de 08:00 a 19:30 Hrs</p>

          </div>
          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 interior">
            <p className="titulo">Sede Concepción</p>
            <p className="datos"><span>Dirección: </span> Calle Angol 341, Concepción</p>
            <p className="datos"><span>Teléfono: </span> 600 300 1515</p>
            <p className="datos"><span>Correo: </span> concepcion@liche.cl</p>
            <p className="datos"><span>Horario de atencion: </span> </p>
            <p className="datos">Lunes a Viernes de 08:00 a 19:00 Hrs</p>
            <p className="datos">Sabado de 10:00 a 14:00 Hrs</p>
          </div>
          <div className="col-md-4 col-lg-4 col-xl-4 col-sm-12 col-xs-12 col-12 interior">
            <p className="titulo">Ayuda telefónica</p>
            <p className="datos"><span>Horario de atencion: </span> </p>
            <p className="datos">Lunes a Viernes de 08:00 a 20:00 Hrs</p>
            <p className="datos">Sabado de 09:00 a 13:00 Hrs</p>
            <p className="datos"><span>Teléfono: </span> 600 300 1515</p>
          </div>

        </div>
      </div> */}


      {/* boton ir a shop */}
      {/* <div className="view-more round-btn text-center toggle-btn6 col-12 pb-30">
        <Link
          className="loadMore6"
          to={process.env.PUBLIC_URL + "/medicamentos"}
        >
          Ir a comprar
        </Link>
      </div> */}

      {/* category */}
      {/* <CategoryTwoSlider spaceTopClass="pt-100" spaceBottomClass="pb-95" /> */}
      {/* tab product */}
      {/* <TabProductSix spaceBottomClass="pb-70" category="furniture" /> */}
      {/* newsletter */}
      {/* <NewsletterTwo spaceBottomClass="pb-100" /> */}
    </LayoutOne>
  );
};

export default HomeVentaOnline;
